export const CasinoActionTypes = {
  SET_CASINOS: 'SET_CASINOS',
  ADD_CASINO: 'ADD_CASINO',
  UPDATE_CASINO: 'UPDATE_CASINO',
  SET_CASINO: 'SET_CASINO',
  SET_CASINO_OPTIONS: 'SET_CASINO_OPTIONS'
}